import React from 'react';
import * as Cookies from 'js-cookie';
import { toLogin } from './lib';
import { notification } from 'antd';

const getErrorMsg = (code, message) => {
  switch (code) {
    case 500:
      errorTip('安装包格式错误');
      break;
    case 1000:
      errorTip('APP包名已存在');
      break;
    case 1001:
      errorTip('创建icon文件失败');
      break;
    case 1002:
      errorTip('创建apk文件失败');
      break;
    case 1003:
      errorTip('创建md5文件失败');
      break;
    case 1101:
      errorTip('App不存在');
      break;
    case 1102:
      errorTip('与当前上传的App名称不匹配');
      break;
    case 1103:
      errorTip('解析包名错误 ');
      break;
    case 1104:
      errorTip('版本号重复 ');
      break;
    case 1201:
      errorTip('策略不存在 ');
      break;
    case 1202:
      errorTip('策略状态错误 ');
      break;
    case 1301:
      errorTip('策略未找到 ');
      break;
    case 1302:
      errorTip('策略状态错误 ');
      break;
    case 1303:
      errorTip('策略App版本错误');
      break;
    case 1401:
      errorTip('设备分组错误');
      break;
    case 1402:
      errorTip('App参数错误');
      break;
    case 1403:
      errorTip('App不存在或者失效');
      break;
    case 1404:
      errorTip('App名称或版本不在库中');
      break;
    case 1405:
      errorTip('设备号或 App名称或当前版本或者目标版本不在库中');
      break;
    case 1501:
      errorTip('策略不存在');
      break;
    case 1502:
      errorTip('计划不存在');
      break;
    case 1503:
      errorTip('无法撤销已应用的策略');
      break;
    case 1601:
      errorTip('OTA信息缺失');
      break;
    case 1602:
      errorTip('OTA版本错误');
      break;
    case 1603:
      errorTip('设备号未找到');
      break;
    case 1604:
      errorTip('OTA版本未找到');
      break;
    case 1701:
      errorTip('版本未指定');
      break;
    case 1801:
      errorTip('分组未找到');
      break;
    default:
      errorTip(message);
      break;
  }
};
export const errorTip = message =>
  notification['error']({
    message: '操作错误',
    description: message,
    duration: 0
  });
/**
 * Global wrapper for fetch
 * @param {string} input - the url to request
 * @param {object} init - initial variable for request
 * @param {function} success - successful request handler
 * @param {object} failure - code-handler mapped object
 */

export const fetch = async (input, init, success = undefined) => {
  try {
    const token = Cookies.get('token');
    const myHeaders = init.headers ? new Headers(init.headers) : new Headers();
    myHeaders.set('Authorization', `Bearer ${token}`);
    const res = await window.fetch(input, { ...init, headers: myHeaders });
    const json = await (init.method === 'DELETE' ? res : res.json());
    if (json.status && json.status == 403) {
      toLogin();
    }
    if (typeof success === 'function') {
      if (
        json.code &&
        json.code !== 200 &&
        json.code !== 1406 &&
        json.code !== 400
      ) {
        getErrorMsg(json.code, json.message);
      }
      return success(json);
    } else {
      if (json.code && json.code !== 200 && json.code !== 1406) {
        getErrorMsg(json.code, json.message);
      }
      return json;
    }
  } catch (error) {
    console.log(error);
  }
};

export const fetchBlob = async (input, init = {}, success) => {
  try {
    const token = Cookies.get('token');
    const myHeaders = init.headers ? new Headers(init.headers) : new Headers();
    myHeaders.set('Authorization', `Bearer ${token}`);
    const res = await window.fetch(input, { ...init, headers: myHeaders });
    const blob = res.blob();
    if (typeof success === 'function') {
      return success(blob);
    } else {
      return blob;
    }
  } catch (error) {
    console.log(error);
  }
};

export const buildUrl = obj => {
  const query = Object.keys(obj)
    .filter(
      key =>
        obj[key] !== null &&
        obj[key] !== undefined &&
        obj[key] !== '' &&
        obj[key] !== ''
    )
    .map(key => `${key}=${obj[key]}`)
    .join('&');
  return query && '?' + query;
};



// WEBPACK FOOTER //
// ./src/lib/fetchAPI.js